<template>
  <el-container>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t('monitoringCenter.home') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('zi-yuan-zhong-xin') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('sim-ka-guan-li') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="24">
          <el-tabs v-model="activeName" type="border-card">
            <el-row v-show="showFilters">
              <!--      搜索框组件      -->
              <search
              :searchForm="searchForm"
              :operatorTypeData="enumData.operatorTypeData"
              :searchLoading="searchLoading"
              :operatorForSelect="operatorForSelect"
              :stationsForSelect="stationsForSelect"
              :exportLoading="exportLoading"
              @submitSearchForm="submitSearchForm"
              @exportSearchForm="exportSearchForm"
              @operatorSelect="operatorSelect"
              ref="searchForm"
              ></search>
              <el-form>
                <el-col :span="2.5" class="diy-class">
                  <el-form-item>
                    <el-button size="mini" type="primary" @click="simCardAdd" icon="el-icon-plus" class="el-btn"
                               v-if="checkPermission(['bee:res:simCard:saveOrUpdateSimCard'])">{{ $t('xin-zeng-sim-ka') }}
                    </el-button>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
            <!--列表数据-->
            <el-tab-pane :label="$t('sim-ka-lie-biao')" name="simCardList">
              <!--       列表组件       -->
              <list
              :simCardDataTable="simCardDataTable"
              :listLoading="listLoading"
              @simCardEdit="simCardEdit"
              @simCardDelete="simCardDelete"
              @simCardDetail="simCardDetail"
              ></list>
              <!-- 分页组件 -->
              <Pagination v-bind:child-msg="pageparm" @callFather="changePage"></Pagination>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
      <!-- 编辑组件 -->
      <add
      :editForm="editForm"
      :editFormVisible="editFormVisible"
      :operatorForSelect="operatorForSelect"
      :stationsForSelect="stationsForSelect"
      :pilesForSelect="pilesForSelect"
      :operatorTypeData="enumData.operatorTypeData"
      :payTypeData="enumData.payTypeData"
      :editSubmitLoading="editSubmitLoading"
      :businessListTree ="businessListTree"
      @closeEditForm="closeEditForm"
      @editSubmit="editSubmit"

      @operatorSelect="operatorSelect"
      @stationSelect="stationSelect"
      ></add>
      <!--详情组件-->
      <detail
      :detailFormVisible="detailFormVisible"
      :detailForm="detailForm"
      @closeDetailForm="closeDetailForm"
      ></detail>
    </el-main>
  </el-container>
</template>

<script>
  import Pagination from '../../../components/Pagination'
  import simCardApi from '../../resourceCenter/api/simCardApi'
  import commonApi from '../../resourceCenter/api/commonApi'
  import {isInteger,validatePhone} from '../../../common/validator'
  import search from "./simCardManager/search"
  import list from "./simCardManager/list"
  import add from "./simCardManager/add"
  import detail from "./simCardManager/detail"
  import businessApi from "../api/businessApi.js"
  export default {
    name: 'simCardManager',
    data() {
      return {
        enumData: [{
          operatorTypeData:"",
          payTypeData:""
        }],
        stationsForSelect: '',
        operatorForSelect: [],
        pilesForSelect: '',
        activeName: 'simCardList',
        showFilters: true,
        listLoading: false,
        simCardDataTable: [{}],
        exportLoading:false,
        // 多选集合
        simCardDataSelection: [],

        // 查询
        searchLoading: false,
        searchFormVisible: false,
        searchForm: {// 未初始化不传递参数，影响后台接查询
        },
        // 编辑
        editFormVisible: false,
        editSubmitLoading: false,
        editForm: {},
        // 详情
        detailFormVisible: false,
        detailForm: {},
        // 分页参数
        pageparm: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
         businessListTree:[{}],
        activeNames: ['basicInformation']
      }
    },
    methods: {
      resetSearchForm() {
        this.searchForm = {}
      },
      submitSearchForm() {
        this.$refs.searchForm.$children[0].validate((valid) => {
          if (!valid) {
            return;
          }
          this.searchLoading = true
          this.listLoading = true
          // let param = Object.assign({}, this.stationSearchForm)
          // para.date = (!para.date || para.date == '') ? '' : util.formatDate.format(new Date(para.date), 'yyyy-MM-dd');
          this.pageparm.t = this.searchForm
          let param = Object.assign({}, this.pageparm)
          simCardApi.getSimCards(param).then((res) => {
            if (res.code === 0) {
              this.pageparm.total = res.data.total
              this.simCardDataTable = res.data.records
              // this.$message({
              //   message: res.message,
              //   type: 'success'
              // })
            } else {
              // this.$message.error(res.message)
            }
            this.searchLoading = false
            this.listLoading = false
          })
        })
      },
      exportSearchForm(){
        this.$refs.searchForm.$children[0].validate((valid) => {
          if (!valid) {
            return;
          }
          this.exportLoading = true


          let param = Object.assign({},  this.searchForm)
          simCardApi.exportSim(param).then((res) => {
              const blob = new Blob([res],{
                type: 'application/vnd.ms-excel;charset=utf-8'
              })
              const downloadElement = document.createElement('a')
              const href = window.URL.createObjectURL(blob)
              downloadElement.download = this.$t('sim-ji-lu-xlsx')
              downloadElement.href = href
              document.body.appendChild(downloadElement)
              downloadElement.click()
              document.body.removeChild(downloadElement) // 下载完成移除元素
              window.URL.revokeObjectURL(href) // 释放掉blob对象
            }).finally(() => {
              this.exportLoading = false
            })
          })
      },
      // 多选
      simCardDataSelectionChange(val) {
        this.simCardDataSelection = val
      },
      simCardAdd() {
        this.$nextTick(() => {
          this.editFormVisible = true
          this.editForm = Object.assign({})
        })
      },
      simCardDetail(index, row) {
        this.detailFormVisible = true
        this.detailForm = Object.assign({}, row)
      },
      closeDetailForm(){
        this.detailFormVisible=false
      },
      simCardEdit(index, row) {
        this.operatorSelect(row.operatorId)
        // 编辑场站选中时
        this.stationSelect(row.stationId)
        // 编辑设备选中时
        this.editFormVisible = true
        this.editForm = Object.assign({}, row)
        this.editForm.operatorType = this.editForm.operatorTypeCode
        this.editForm.payType = this.editForm.payTypeCode
      },
      editSubmit(editForm) {
        editForm.validate((valid) => {
            if (!valid) {
              return;
            } else {
              this.$confirm(this.$t('deviceControl.AreYouSureToSubmit'), this.$t('deviceControl.prompt'), {}).then(() => {
                this.editSubmitLoading = true
                let param = JSON.stringify(this.editForm)
                simCardApi.saveOrUpdateSimCard(param).then((res) => {
                  this.editSubmitLoading = false
                  if (res.code === 0) {
                    this.$message({
                      message: res.message,
                      type: 'success'
                    })
                    this.submitSearchForm()
                  } else {
                    this.$message.error(res.message)
                  }
                  this.editFormVisible = false
                }).catch((error)=>{
                  this.editSubmitLoading = false
                })
              })
            }
        })
      },
      closeEditForm(){
        this.editFormVisible=false
      },
      simCardDelete(index, row) {
        this.$confirm(this.$t('que-ding-yao-shan-chu') + row.cardNo + this.$t('ma-0'), this.$t('alaramMonitor.message5'), {
          confirmButtonText: this.$t('deviceControl.confirm'),
          cancelButtonText: this.$t('alaramMonitor.cancel'),
          type: 'warning'
        })
          .then(() => {
            simCardApi.deleteSimCard(row.id).then((res) => {
              if (res.code === 0) {
                this.$message({
                  message: res.message,
                  type: 'success'
                })
                this.submitSearchForm()
              } else {
                this.$message.error(res.message)
              }
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('alaramMonitor.message8')
            })
          })
      },
      changePage() {
        this.submitSearchForm()
      },
      // 加载下拉框
      loadSelectItem() {
        simCardApi.getSimCardEnum().then((res) => {
          this.enumData.operatorTypeData = JSON.parse(res.operatorTypeData);
          this.enumData.payTypeData = JSON.parse(res.payTypeData);
        })
      },
      loadForSelect() {
        // 站下拉框
        // let operatorId = this.$store.getters.operatorIds
        // commonApi.stationsForSelectByOperatorId(operatorId).then((res) => {
        //   if (res.code === 0) {
        //     this.stationsForSelect = res.data
        //   }
        // })
        // 运营商下拉框
        commonApi.getOperatorsTree().then((res) => {
          if (res.code === 0) {
            this.operatorForSelect = res.data
          }
        })
      },
      operatorSelect(val) {
        commonApi.stationsForSelectByOperatorId([val]).then((res) => {
          if (res.code === 0) {
            this.stationsForSelect = res.data
          }
        })
        let param={}
        param.operatorId=val
         businessApi.getBusinessListTree(param).then((res) =>{

             this.businessListTree=res.data
             console.log(this.businessListTree)
         })

        console.log(this.businessListTree)
      },
      // 编辑场站选中时
      stationSelect(val) {
        commonApi.pilesForSelect(val).then((res) => {
          if (res.code === 0) {
            this.pilesForSelect = res.data
          }
        })
      },
    },
    components: {
      Pagination,
      search,
      list,
      add,
      detail
    },
    created: function () {
      this.loadSelectItem()
      this.loadForSelect()
    },
    mounted: function () {
      this.submitSearchForm()
    }
  }
</script>

<style lang="less" scoped>
  .el_search {
    background-color: teal;
    color: white;
  }

  .el_clear {
    background-color: darkorange;
    color: white;
  }

  .el-btn {
    /*float: right;*/
    margin-bottom: 15px;
  }

  /deep/ .search_form {
    .el-form-item__content {
      .el-input {
        width: auto;
      }
    }
  }

  /deep/ .edit_form, /deep/ .detail_form {
    height: 400px;
    overflow: auto;

    .el-form-item__label {
      color: rgba(0, 0, 0, 0.47);
    }
  }
  /deep/ .diy-class {
    .el-form-item__content {
      line-height: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/simCardManager.vue